import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    // Refresh AOS animations 👇
    AOS.refreshHard();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
